import { useEffect } from 'react';
const PIXEL_ID = '1554114992235473';
export function MetaPixel() {
  useEffect(() => {
    const w = window as unknown as {
      fbq?: ((...args: unknown[]) => void) & {
        callMethod?: (...args: unknown[]) => void;
        queue?: unknown[];
        push?: unknown;
        loaded?: boolean;
        version?: string;
      };
      _fbq?: unknown;
    };
    if (!w.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, args);else fbq.queue?.push(args);
      } as NonNullable<typeof w.fbq>;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      w.fbq = fbq;
      w._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq?.('init', PIXEL_ID);
    w.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-82" data-mp="18frsmpwjauz4">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-83" data-mp="18f8dti26kmpb" />
    </noscript>;
}